import { MeetingStand } from '@conference/b2b/_models/meeting-stand';

export class MeetingArea {
    id: number;
    numberOfStands: number;
    meetingStands: MeetingStand[] = [];
    date: Date;
    conferenceId: number;
}